import React, { Component } from "react";
import styles from "./routes.module.scss";
import { MapContainer, MapConsumer, TileLayer, Marker, GeoJSON, Popup , Circle} from "react-leaflet";
import { withMapControl } from "../../../shared/containers/containerMapControl";
import L from "leaflet";
/* import { ControlPointIcon } from "./ControlPointIcon"; */
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { withLogisticRoutes } from "../../../shared/containers/containerLogisticRoutes";
import { ControlPointIcon } from "../ControlPoints/ControlPointIcon";

class MapRouteView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      maxLocation: null,
      nimLocation: null,
      averageLocation: null,
    };
  }

  componentDidMount() {
    const { controlPoints } = this.props;

    const longitudes = controlPoints.map((x) => {
      return x.longitude;
    });

    const latitudes = controlPoints.map((x) => {
      return x.latitude;
    });

    const maxLocation = {
      lon: Math.max(...longitudes),
      lng: Math.max(...latitudes),
    };

    const minLocation = {
      lon: Math.min(...longitudes),
      lng: Math.min(...latitudes),
    };

    this.setState({ maxLocation, minLocation });
  }

  onClose() {
    const { onCloseHandler } = this.props;

    onCloseHandler();
  }

  getIcon(color, number) {
    return L.divIcon({
      html: `<div style="display: flex">${ControlPointIcon.getIcon(color)} <div><b>${number}</b></div></div>`,
      className: "svg-icon",
      iconSize: [26, 26],
      iconAnchor: [6, 25],
    });
  }

  render() {
    const { mapBaseLayer, geojsonData, controlPoints, height = 300 } = this.props;
    if (geojsonData === null || geojsonData === undefined || geojsonData.routeGeometries === null || controlPoints.length <= 1) return null;
    const { maxLocation, minLocation } = this.state;

    let distance = 0;
    let duration = 0;

    if (geojsonData.routeGeometries !== undefined) {
      geojsonData.routeGeometries.routes.forEach((route) => {
        distance += route.distance;
        duration += route.duration;
      });
    }

    if (geojsonData.tripGeometries !== undefined) {
      geojsonData.tripGeometries.routes.forEach((route) => {
        distance += route.distance;
        duration += route.duration;
      });
    }

    const toTimeString = (seconds) => {
      const endDate = new Date(new Date(seconds * 1000).getTime() + new Date().getTimezoneOffset() * 60000);

      return `${endDate.getDate() > 1 ? endDate.getDate() + " д." : ""} ${endDate.toTimeString().substring(0, 8)}`;
    };

    return (
      <div style={{ height: `${height}px`, position: "realative" }}>
        <div style={{ position: "absolute", zIndex: "600", right: "15px", top: "15px" }} onClick={this.onClose.bind(this)}>
          <HighlightOffIcon style={{ color: "red", cursor: "pointer" }} />
        </div>

        <div className={styles.routeParamsPanel}>
          <p>Дистанция: {(distance / 1000).toFixed(2)} км.</p>
          <p>Время в пути: {toTimeString(duration)}</p>
        </div>

        <MapContainer
          /*   key={`${controlPoint.id}`} */
          center={[53, 27]}
          zoom={14}
          maxZoom={mapBaseLayer.maxZoom}
          minZoom={3}
          crs={mapBaseLayer.crs}
          zoomControl={true}
          attributionControl={false}
          doubleClickZoom={true}
          scrollWheelZoom={true}
          dragging={true}
          animate={true}
          easeLinearity={0.35}
          className={styles.mapWrapper}
          style={{ width: "100%" }}
        >
          <MapConsumer>
            {(map) => {
              map.fitBounds(
                new L.latLngBounds([new L.latLng(minLocation.lng, minLocation.lon), new L.latLng(maxLocation.lng, maxLocation.lon)]).pad(
                  0.2
                )
              );

              return null;
            }}
          </MapConsumer>

          {mapBaseLayer.url.map((_url, index) => {
            return <TileLayer key={mapBaseLayer.name + index} url={_url} updateWhenIdle={true} maxZoom={mapBaseLayer.maxZoom} />;
          })}

          {controlPoints.map((controlPoint, index) => {
            return (
              <div>
                <Marker
                  key={controlPoint.id}
                  draggable={false}
                  icon={this.getIcon(index === 0 ? "green" : index === controlPoints.length - 1 ? "red" : "black", index + 1)}
                  position={[controlPoint.latitude, controlPoint.longitude]}
                >
                  <Popup className="mapPopup">
                    <div className="mapPopupContent">
                      <span style={{ fontSize: "11px" }}>Наименование: {controlPoint.title}</span>
                    </div>
                    <div className="mapPopupContent">
                      <span style={{ fontSize: "11px" }}>Адрес: {controlPoint.address}</span>
                    </div>
                    <div className="mapPopupContent">
                      <span style={{ fontSize: "11px" }}>Адрес по локации: {controlPoint.geocoderAddress}</span>
                    </div>

                    {controlPoint.description !== null && controlPoint.description !== undefined ? (
                      <div className="mapPopupContent">
                        <span style={{ fontSize: "11px" }}>Описание: {controlPoint.description}</span>
                      </div>
                    ) : null}

                    <div className="mapPopupContent">
                      <span style={{ fontSize: "11px" }}>Радиус: {controlPoint.radius} м.</span>
                    </div>
                    <div className="mapPopupContent">
                      <span style={{ fontSize: "11px" }}>Максимальная скорость: {controlPoint.maxSpeed} км./ч.</span>
                    </div>
                  </Popup>
                </Marker>
                <Circle
                  key={`${controlPoint.radius} ${controlPoint.latitude} ${controlPoint.longitude}`}
                  center={[controlPoint.latitude, controlPoint.longitude]}
                  radius={Number(controlPoint.radius)}
                />
              </div>
            );
          })}

          {geojsonData.routeGeometries !== null && geojsonData.routeGeometries !== undefined
            ? geojsonData.routeGeometries.routes.map((routeGeometry, index) => {
                return <GeoJSON key={index} data={routeGeometry.geometry} />;
              })
            : null}

          {geojsonData.tripGeometries !== null && geojsonData.tripGeometries !== undefined
            ? geojsonData.tripGeometries.routes.map((routeGeometry, index) => {
                return <GeoJSON key={index} data={routeGeometry.geometry} />;
              })
            : null}

          {this.props.children}
        </MapContainer>
      </div>
    );
  }
}

export default withLogisticRoutes(withMapControl(React.memo(MapRouteView)));
